import { Component, ElementRef, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MainService } from "../../../services/MainService";
import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types';

@Component({
  selector: 'images-slider',
  templateUrl: './images-slider.component.html',
  styleUrls: ['./images-slider.component.scss'],
})
export class ImagesSliderComponent implements OnInit, AfterViewInit {
  @ViewChild('swiper', { static: false }) swiperRef!: ElementRef;

  @Input() images: Array<any> = [];
  @Input() height: number = 200;
  @Input() autoplay: boolean = true;
  @Input() bottomListShow: boolean = false;
  @Input() style: object = {};

  public ready: boolean = false;
  public videotypes: string = '.mp4';
  public imgagesurls: string[] = [];
  public swiperInstance: any;

  constructor(public mainService: MainService) {}

  ngOnInit() {
    this.style = {
      ...this.style,
      'max-height': `${this.height}px`,
      'background-size': 'contain',
    };

    this.imgagesurls = this.images.map(img => img.data?.imagefullurl || '');

    this.autoplay = this.mainService.sliderAutoPlay;
    this.ready = true;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.swiperRef?.nativeElement?.swiper) {
        this.swiperInstance = this.swiperRef.nativeElement.swiper;

        console.log("Swiper initialized", this.swiperInstance);
      } else {
        console.error("Swiper instance not found in nativeElement");
      }
    }, 100); // Ensure DOM updates first
  }

  showImage(image) {
      if (this.mainService.isbrowser) {
          window.open(image)
      } else {
          // this.photoViewer.show(image);
      }
  }

  slideTo(index: number) {
    if (this.swiperInstance) {
      console.log(`Sliding to index: ${index}`);
      this.swiperInstance.slideTo(index);
    } else {
      console.error("Swiper instance is not initialized yet");
    }
  }
}